export function addKeyDownTabbingListener(element, keyCode) {
  if (keyCode !== 9)
    return;
  element.classList.add('is-tabbing');
}
export function addMouseDownTabbingListener(element) {
  element.classList.remove('is-tabbing');
}
export function getActiveElementInShadowDom() {
  var _a;
  let activeElement = document.activeElement;
  while ((_a = activeElement === null || activeElement === void 0 ? void 0 : activeElement.shadowRoot) === null || _a === void 0 ? void 0 : _a.activeElement) {
    activeElement = activeElement.shadowRoot.activeElement;
  }
  return activeElement;
}
export function focusTrap(element, tabEvent) {
  const focusableElements = element.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
  if (!focusableElements.length) {
    tabEvent.preventDefault();
    return;
  }
  const firstFocusableEl = focusableElements[0];
  const lastFocusableElement = focusableElements[focusableElements.length - 1];
  const activeElement = getActiveElementInShadowDom();
  if (focusableElements.length === 1) {
    tabEvent.preventDefault();
    firstFocusableEl.focus();
  }
  else if (!element.contains(activeElement)) {
    tabEvent.preventDefault();
    (tabEvent.shiftKey ? lastFocusableElement : firstFocusableEl).focus();
  }
  else if (tabEvent.shiftKey && activeElement === firstFocusableEl) {
    tabEvent.preventDefault();
    lastFocusableElement.focus();
  }
  else if (!tabEvent.shiftKey && activeElement === lastFocusableElement) {
    tabEvent.preventDefault();
    firstFocusableEl.focus();
  }
}
//# sourceMappingURL=tabbing.js.map
